import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Navigation from "@/components/Navigation";
import { CreditCard, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Payment Methods available
const PAYMENT_METHODS = [
  { name: "Mastercard", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/200px-Mastercard-logo.svg.png", description: "Credit & Debit Cards" },
  { name: "Visa", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/200px-Visa_Inc._logo.svg.png", description: "Credit & Debit Cards" },
  { name: "Revolut Pay", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Revolut.svg/200px-Revolut.svg.png", description: "Digital Banking" },
  { name: "Open Banking", logo: null, icon: "🏦", description: "Direct Bank Connection" },
  { name: "SPEI", logo: null, icon: "🇲🇽", description: "Mexico Bank Transfer" },
  { name: "Apple Pay", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Apple_Pay_logo.svg/200px-Apple_Pay_logo.svg.png", description: "Mobile Wallet" },
  { name: "SEPA", logo: null, icon: "🇪🇺", description: "European Bank Transfer" },
  { name: "Google Pay", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Google_Pay_Logo.svg/200px-Google_Pay_Logo.svg.png", description: "Mobile Wallet" },
  { name: "PIX", logo: null, icon: "🇧🇷", description: "Brazil Instant Payment" },
  { name: "Bank Transfer", logo: null, icon: "🏛️", description: "Standard Wire Transfer" }
];

export default function PaymentMethodsPage({ user, onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <Navigation user={user} onLogout={onLogout} />
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <Button 
            variant="ghost" 
            onClick={() => navigate(-1)}
            className="mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" /> Back
          </Button>

          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center justify-center gap-3">
              <CreditCard className="w-8 h-8 text-blue-600" />
              Payment Methods
            </h1>
            <p className="text-gray-600">
              <span className="font-semibold text-blue-600">{PAYMENT_METHODS.length} ways</span> to fund your transfers
            </p>
          </div>

          <Card className="border-blue-200 bg-white">
            <CardHeader>
              <CardTitle className="text-center text-gray-700">
                Multiple convenient options to send money
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                {PAYMENT_METHODS.map((method) => (
                  <div
                    key={method.name}
                    className="flex flex-col items-center justify-center p-6 rounded-xl bg-gradient-to-br from-gray-50 to-blue-50 border border-blue-100 hover:shadow-lg hover:border-blue-300 transition-all"
                  >
                    {method.logo ? (
                      <img 
                        src={method.logo} 
                        alt={method.name}
                        className="h-12 w-auto object-contain mb-3"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <span className="text-4xl mb-3">{method.icon}</span>
                    )}
                    <span className="text-sm font-semibold text-gray-800 text-center">
                      {method.name}
                    </span>
                    <span className="text-xs text-gray-500 text-center mt-1">
                      {method.description}
                    </span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          <div className="mt-8 text-center text-sm text-gray-500">
            <p>
              All payment methods are secure and processed through our trusted partners.
            </p>
            <p className="mt-1">
              Powered by <a href="https://guardarian.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Guardarian</a> payment infrastructure
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
